import { Action, createReducer, on } from '@ngrx/store';
import {
  getSignedUrlAction, getSignedUrlSuccessAction, getSignedUrlFailureAction,
} from './get-signed-url.actions';
import { GetSignedUrlState } from './get-signed-url.types';

const initialState = {
  loading: false,
  loaded: false,
};

const getSignedUrlReducer = createReducer<GetSignedUrlState>(
  initialState,
  on(
    getSignedUrlAction,
    () => ({
      loading: true,
      loaded: false,
    })
  ),
  on(
    getSignedUrlSuccessAction,
    (state, action) => ({
      ...state,
      loading: false,
      loaded: true,
      url: action.url,
      error: null,
    })
  ),
  on(
    getSignedUrlFailureAction,
    (state, action) => ({
      ...state,
      loading: false,
      loaded: false,
      error: action.error,
    })
  ),
);

export const reducer = (state: GetSignedUrlState, action: Action) => getSignedUrlReducer(state, action);
